export const environment = {
    production: true,
    pathApi: 'https://bps-identity-staging.azurewebsites.net/api/',
    name: 'staging'
  };
